module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-heart-fill-65c57bffd0b259abb1a93358e544e75e.svg";